
<form [formGroup]="tableFilterForm" class="search__form sticky-top bg-white pt-2">
    <mat-form-field class="search__form_field" appearance="outline">
        <mat-label>{{'input_search_person' | translate}}</mat-label>
        <input matInput type="text" formControlName="textFilter" placeholder="{{'invite_search_txt_hint' | translate}}">
        <button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="tableFilterForm.controls.textFilter.reset()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
    <mat-form-field class="search__form_field" appearance="outline">
        <mat-label>{{'invite_filter_status' | translate}}</mat-label>
        <mat-select formControlName="statusFilter" multiple>
            <mat-select-trigger>
                {{'invite_status.'+ (tableFilterForm.controls.statusFilter.value ? tableFilterForm.controls.statusFilter.value[0] : '') | translate}}
                <span *ngIf="tableFilterForm.controls.statusFilter.value?.length > 1" class="example-additional-selection">
                    (+{{tableFilterForm.controls.statusFilter.value.length - 1}})
                </span>
            </mat-select-trigger>
            <mat-option *ngFor="let status of statuses" [value]="status">{{'invite_status.'+status | translate}}</mat-option>
        </mat-select>
    </mat-form-field>
</form>
<div *ngIf="show" class="table-container">
    <table mat-table [dataSource]="dataSource" id="table-person-invite" class="p-2" matSort>    
        <ng-container matColumnDef="Person" sticky>
            <th mat-header-cell *matHeaderCellDef class="test-header" mat-sort-header> Person </th>
            <td mat-cell *matCellDef="let element">
                {{element['Person']}}
            </td>
        </ng-container>
        <ng-container matColumnDef="invitation_link" sticky>
            <th mat-header-cell *matHeaderCellDef class="test-header"> {{'more_options_inv_link' | translate}} </th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button matTooltip="{{ 'hint_copy_invitation_link' | translate}}"  (click)="getInvitationLink(element); $event.stopPropagation();">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </td>
        </ng-container>
        <ng-container [matColumnDef]="column" *ngFor="let column of columnsToDisplayWOPerson">
            <th mat-header-cell *matHeaderCellDef> {{column}} </th>
            <td mat-cell *matCellDef="let element">
                <div *ngIf="column == 'Person'">
                    <button mat-icon-button matTooltip="{{ 'hint_copy_invitation_link' | translate}}"  (click)="getInvitationLink(element); $event.stopPropagation();">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                    {{element[column]}}
                </div>
                <div *ngIf="column != 'Person'">
                    <div style="display: flex; line-height: 48px; align-items: center;">
                        {{ 'invite_status.'+element[column]?.processingStatus | translate }} <mat-icon style="cursor: pointer;" [matMenuTriggerFor]="menu">arrow_drop_down</mat-icon> 
                    </div>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item *ngFor="let st of statuses" (click)="editStatus(element[column], st)">{{'invite_status.'+st | translate}}</button>
                        <!-- <button mat-menu-item>Item 2</button> -->
                    </mat-menu>
                </div>
            </td>
        </ng-container>
        <!-- <ng-template #othercols>
            <ng-container [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef> {{column}} </th>
                <td mat-cell *matCellDef="let element">
                    <div *ngIf="column == 'Person'">
                        <button mat-icon-button matTooltip="{{ 'hint_copy_invitation_link' | translate}}"  (click)="getInvitationLink(element); $event.stopPropagation();">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                        {{element[column]}}
                    </div>
                    <div *ngIf="column != 'Person'">
                        <div style="display: flex; line-height: 48px; align-items: center;">
                            {{ 'invite_status.'+element[column]?.processingStatus | translate }} <mat-icon style="cursor: pointer;" [matMenuTriggerFor]="menu">arrow_drop_down</mat-icon> 
                        </div>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item *ngFor="let st of statuses" (click)="editStatus(element[column], st)">{{'invite_status.'+st | translate}}</button>
                            
                        </mat-menu>
                    </div>
                </td>
            </ng-container>
        </ng-template> -->
      
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
    </table>
</div>
<mat-paginator [hidden]="dataSource?.data?.length < 1" [pageSizeOptions]="paginatorPageSizeOptions">
</mat-paginator>

<button mat-raised-button [matMenuTriggerFor]="menu" class="third-btn" [hidden]="dataSource?.data?.length < 1">{{ 'btn_excel_export' | translate }}</button>
<mat-menu #menu="matMenu">
    <button mat-menu-item (click)="exportFilteredInvitations()">{{'btn_export_filtered_invitations' | translate}}</button>
    <button mat-menu-item (click)="exportAllInvitations()">{{'btn_export_all_invitations' | translate}}</button>
    <button mat-menu-item (click)="exportApprovedInvitations()">{{'btn_export_pending_inv' | translate }}</button>
</mat-menu>
